import React from 'react';

export const DragIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="11"
    viewBox="0 0 8 11"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <rect width="1.99" height="1.99" fill="#6595ce"/>
    <rect x="3" width="1.99" height="1.99" fill="#6595ce"/>
    <rect x="6.01" width="1.99" height="1.99" fill="#6595ce"/>
    <rect y="3" width="1.99" height="1.99" fill="#6595ce"/>
    <rect x="3" y="3" width="1.99" height="1.99" fill="#6595ce"/>
    <rect x="6.01" y="3" width="1.99" height="1.99" fill="#6595ce"/>
    <rect y="6" width="1.99" height="1.99" fill="#6595ce"/>
    <rect x="3" y="6" width="1.99" height="1.99" fill="#6595ce"/>
    <rect x="6.01" y="6" width="1.99" height="1.99" fill="#6595ce"/>
    <rect y="9.01" width="1.99" height="1.99" fill="#6595ce"/>
    <rect x="3" y="9.01" width="1.99" height="1.99" fill="#6595ce"/>
    <rect x="6.01" y="9.01" width="1.99" height="1.99" fill="#6595ce"/>
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/drag-icon.js